import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Acoes from '../pages/acoes-talkative.js';
import Artigo from '../pages/artigo';
import Ativacao from '../pages/ativacao-de-base.js';
import Blog from '../pages/blog';
import Contato from '../pages/contato.js';
import Devolucao from '../pages/devolucao.js';
import Equipe from '../pages/equipe.js';
import Gestao from '../pages/gestao-de-apoio.js';
import Home from '../pages/index';
import LandingPage from '../pages/landing-page.js';
import Midia from '../pages/midia.js';
import Parceiros from '../pages/parceiros.js';
import PreHome from '../pages/pre-home';
import Sobre from '../pages/sobre.js';
import Termos from '../pages/termos.js';
import Tutoriais from '../pages/tutoriais.js';
import Vagas from '../pages/vagas.js';
import Navbar from './Navbar';
import ScrollToTop from './ScrollToTop';
import SetCookie from './SetCookie';
import RedirectToHome from '../pages/redirect-to-home'



class AppHolder extends Component {

  static contextTypes = {
    t: PropTypes.func.isRequired
  }

  componentDidMount() {
    window.Intercom("boot", {
      app_id: "koi2jxsb"
    });
  }

  render() {
    return (
      <Router>
        <ScrollToTop>
          <SetCookie>
            <Navbar />
            <Switch>
              <Route exact path="/" component={PreHome}/>
              <Route path={this.context.t('/pequeno-negocio', {}, 'Rota para /pequeno-negocio')} component={Home}/>
              <Route path={this.context.t('/grande-empresa', {}, 'Rota para /grande-empresa')} component={Home}/>
              <Route path={this.context.t('/politica', {}, 'Rota para /politica')} component={Home}/>
              <Route path={this.context.t('/personalidade', {}, 'Rota para /personalidade')} component={Home}/>
              <Route path={this.context.t('/endomarketing', {}, 'Rota para /endomarketing')} component={Home}/>
              <Route path={this.context.t('/causa', {}, 'Rota para /causa')} component={Home}/>
              <Route path={this.context.t('/ações-especiais', {}, 'Rota para /ações-especiais')} component={Acoes}/>
              <Route path={this.context.t('/ativação-de-base', {}, 'Rota para /ativação-de-base')} component={Ativacao}/>
              <Route exact path={this.context.t('/checkout', {}, 'Rota para /checkout')} component={RedirectToHome}/>
              <Route path={this.context.t('/checkout/:step', {}, 'Rota para /checkout/:step')} component={RedirectToHome}/>
              <Route path={this.context.t('/contato', {}, 'Rota para /contato')} component={Contato}/>
              <Route path={this.context.t('/equipe', {}, 'Rota para /equipe')} component={Equipe}/>
              <Route path={this.context.t('/gestão-de-apoiadores', {}, 'Rota para /gestão-de-apoiadores')} component={Gestao}/>
              <Route path={this.context.t('/na-mídia', {}, 'Rota para /na-mídia')} component={Midia}/>
              <Route path={this.context.t('/parceiros', {}, 'Rota para /parceiros')} component={Parceiros}/>
              <Route path={this.context.t('/termos', {}, 'Rota para /termos')} component={Termos}/>
              <Route path={this.context.t('/devolucao', {}, 'Rota para /devolucao')} component={Devolucao} />
              <Route path={this.context.t('/sobre', {}, 'Rota para /sobre')} component={Sobre}/>
              <Route path={this.context.t('/tutoriais', {}, 'Rota para /tutoriais')} component={Tutoriais}/>
              <Route path={this.context.t('/vagas', {}, 'Rota para /vagas')} component={Vagas}/>
              <Route exact path={this.context.t('/artigos', {}, 'Rota para /artigos')} component={Blog} />
              <Route exact path={this.context.t('/artigos/:id', {}, 'Rota para /artigos/:id')} component={Artigo} />
              <Route component={LandingPage}/>
            </Switch>
          </SetCookie>
        </ScrollToTop>
      </Router>
    )
  }
}

const mapStateToProps = (state) => ({
})

const mapDispatchToProps =  ({
})

const App = connect(
  mapStateToProps,
  mapDispatchToProps
)(AppHolder)

export default App



// WEBPACK FOOTER //
// ./src/components/App.js